<div class="power-app-wrapper">
  <div class="iframe-container">
    <iframe 
      [src]="powerAppUrl | safeUrl"
      allowfullscreen>
    </iframe>
  </div>
</div>
